<template>
  <div class="two"> 
    <div v-for="row in rows" :key="row" class="labelbody">
      <div>
        <div>{{row.culture_code}}</div>
        <div>{{row.store}}</div>
        <!-- <div class="font-weight-bold" v-for="srow in row.species.rows" :key="srow"> {{ srow.species.name }} </div> -->
        <div v-for="col in meta.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'species'" v-bind="{mode:'labelprint', column:col, initValue:row[col.fieldname], meta:meta, rowobject:row}" v-model="row[col.fieldname]"/>
        </div> 
      </div>
      <date-widget v-bind="{mode:'view'}" v-model="date" /> 
      <div>- - - - - - - ✂ - - - - - - - </div>
      <p>&nbsp;</p>
    </div>
  </div>
</template>
<!--
<div class="text-right">{{row.mainstorage.name}} {{row.localcollnumber}}</div><br>


-->

<script>
import PointWidget from '@/components/widgets/PointWidget.vue';
import DateWidget from '@/components/widgets/DateWidget.vue';
export default {
  name: 'standard-live-culture-print-page',
  components: {
    PointWidget,
    DateWidget,

  },
  props:['meta', 'rows'],
  data(){ 
    return {
      date: new Date(),
    }
  },
  methods: {

  },

}
</script>

<style scoped>
@media print {
  .two {
    column-count: 2;
    gap: 1cm;
    column-rule: 1px dotted #666;
    font-family:'Times New Roman';
    font-size: 10px;
  }
  .one {
    column-count: 1;
    -webkit-column-count: 1;
    -moz-column-count: 1;
    font-family:'Times New Roman';
    font-size: 10px;
  }
  @page {
    margin: 0.5cm;
  }
  .labelbody {
    page-break-inside: avoid;
  }
}
</style>